export const publishChatStartedEvent = () => {
  window.dispatchEvent(new CustomEvent('jl-digital-conversations-chat-started-successfully', {}))
}
